<template>
  <div class="practice-card-comp">
    <div class="header">
      <div class="title">
        <span class="tag" :class="[calcStatus()]">{{ calcStatusLabel() }}</span>
      </div>
      <dropdown-menu menu="更多操作" menu-type="span" @action="handleAction" :drop-down-items="dropDownItems">
        <template #menu>...</template>
      </dropdown-menu>
    </div>

    <div class="main" @click.prevent="navToTrainingDetail">
      <img src="../assets/img_practice_flag@2x.png" />

      <div class="title">
        {{ trainingInfo.name }}
      </div>
    </div>

    <div class="info-box" @click.prevent="navToTrainingDetail">
      <div class="item">
        <div class="label">布置班级</div>
        <div class="value">{{ showClazzName(trainingInfo.class_vo_list) }}</div>
      </div>
      <div class="item">
        <div class="label">练习时间</div>
        <div class="value">
          {{ formatDate(trainingInfo.start_datetime) }} - {{ formatDate(trainingInfo.end_datetime) }}
        </div>
      </div>

      <div class="item">
        <div class="label">布置教师</div>
        <div class="value">{{ trainingInfo.teacher_vo.teacher_name }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Emit, Prop } from 'kuaidong-component'
import { DateUtil, DateWrapper } from 'kuaidong-lib'
import { FileExportService, NewCourseLiveService } from 'kuaidong-service'
import { AWinter2023 } from 'kuaidong-api'
import DropdownMenu from '@/components/StudentManagement/DropdownMenu.vue'
import { Clazz, ITrainingListItem } from 'kuaidong-model'
@Component({
  components: {
    DropdownMenu,
  },
})
export default class PracticeCard extends BaseComponent {
  @Prop({ type: Object, required: true })
  trainingInfo!: ITrainingListItem

  actionVisible = false

  get isUnStart() {
    const startBegin = DateUtil.beginningOfDay(new DateWrapper(this.trainingInfo.start_datetime).date)
    const now = DateUtil.beginningOfDay(new DateWrapper(new Date()).date)
    return now < startBegin
  }

  get isEnd() {
    const endTime = DateUtil.endOfDay(new DateWrapper(this.trainingInfo.end_datetime).date)
    const now = DateUtil.beginningOfDay(new DateWrapper(new Date()).date)
    return now >= endTime
  }

  get service() {
    return NewCourseLiveService
  }

  get dropDownItems() {
    const items: {
      label: string
      action: string
      type?: 'dangerous' | 'text'
    }[] = []
    if (this.isUnStart) {
      items.push({
        label: '调整时间',
        action: 'updateTime',
        type: 'text',
      })
    }

    if (this.isEnd) {
      items.push({
        label: '下载数据',
        action: 'download',
        type: 'text',
      })
    }

    items.push({
      label: '删除',
      action: 'remove',
      type: 'dangerous',
    })
    return items
  }

  isToday(dt: string) {
    const today = NewCourseLiveService.buildLessonStartDateCN(new DateWrapper(new Date()).showDateStr)
    return today === dt
  }

  showClazzName(clazzInfos: Clazz[]) {
    return this.service.showClazzName(clazzInfos)
  }

  formatDate(dt: string) {
    return new DateWrapper(dt).showDateStr2
  }

  async download() {
    FileExportService.exportFile(AWinter2023.exportPractice, this.trainingInfo.group_id)()
    this.actionVisible = false
  }

  @Emit('click')
  navToTrainingDetail() {
    return
  }

  @Emit('remove')
  handleRemove() {
    this.actionVisible = false
    return this.trainingInfo
  }

  @Emit('updateTime')
  showUpdatePopup() {
    this.actionVisible = false
    return
  }

  calcStatus() {
    if (this.isUnStart) {
      return 'un-start'
    } else if (this.isEnd) {
      return 'end'
    } else {
      return 'progress'
    }
  }

  calcStatusLabel() {
    if (this.isUnStart) {
      return '未开始'
    } else if (this.isEnd) {
      return '已结束'
    } else {
      return '进行中'
    }
  }

  handleAction(actionInfo: { action: string; row: any }) {
    if (actionInfo.action === 'remove') {
      this.handleRemove()
    }

    if (actionInfo.action === 'updateTime') {
      this.showUpdatePopup()
    }
    if (actionInfo.action === 'download') {
      this.download()
    }
  }
}
</script>
<style lang="less">
.practice-card-comp {
  width: 272px;
  height: 274px;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  > .header {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(180deg, rgba(51, 102, 255, 0.05) 0%, rgba(51, 102, 255, 0) 100%);
    > .title {
      > .tag {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;

        &.un-start {
          color: #fe9647;
        }
        &.progress {
          color: #3366ff;
        }
        &.end {
          color: #81848f;
        }
      }
    }
    > .dropdown-menu-comp {
      height: 25px;
      > span {
        color: #c7c9d1;
        letter-spacing: 2px;
      }
    }
  }
  > .main {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    > img {
      width: 60px;
      height: 70px;
      margin: 0 auto;
    }

    > .title {
      margin-top: 18px;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      text-align: center;
      color: #0a1629;
      height: 46px;
      padding: 0 16px;
      box-sizing: border-box;
    }
  }

  > .info-box {
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px;
    background: #fff;
    border-radius: 8px;
    cursor: pointer;

    > .item {
      display: flex;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #8f8f8f;
      margin-top: 8px;
      > .label {
        margin-right: 12px;
      }
    }
  }
}
</style>
